import Vue from "vue";
import App from "./App.vue";
import SM from "./utils/SM.js";

// 开发环境引入vconsole
// if (process.env.NODE_ENV === "development") {
const VConsole = require("vconsole");
new VConsole();
// }
import router from "./router";
import store from "./store";

// 全局挂载SM
Vue.prototype.$sm = SM;
import Vant from "vant";
import "vant/lib/index.css";
import md5 from "js-md5";

Vue.config.productionTip = false;

// 全局引入Vant
Vue.use(Vant);

// 全局挂载md5
Vue.prototype.$md5 = md5;

// 添加全局错误处理
Vue.config.errorHandler = (err, vm, info) => {
  console.error("全局错误捕获:", err);
  console.error("错误信息:", info);
};
Vue.directive("img-fallback", {
  bind(el, binding) {
    el.onerror = () => {
      // 图片加载失败时使用备用图片
      el.src = binding.value || require("@/assets/icon/noimage.png");
      console.warn("图片加载失败，使用备用图片:", el.src);
    };
  },
});
// 添加全局错误处理
window.addEventListener("error", (event) => {
  console.error("全局错误:", event.error);
});

// 添加未处理的Promise拒绝处理
window.addEventListener("unhandledrejection", (event) => {
  console.error("未处理的Promise拒绝:", event.reason);
});
new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
